import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import { formatMoney } from "../../../features/utils/formatMoney";
import { pointsConfig } from "../../../pointsConfig";

function PointsCreateMissionSalesTarget({
  onSalesTargetChange,
  salesTarget,
  data,
  setData,
}) {
  const scopeOptions = [
    { label: "All", value: "ALL" },
    { label: "Flight", value: "FLIGHT" },
    { label: "Hotel", value: "HOTEL" },
    { label: "Tour", value: "TOUR" },
  ];

  return (
    <div className="w-ful flex flex-col pb-[100px]">
      <div className="w-full flex flex-col mb-6">
        <CommonFreeTextInput
          value={formatMoney(salesTarget?.targetAmount)}
          label="Target amount"
          className="mt-4"
          onChange={(val) => {
            const numericVal = val.replace(/\D/g, "");
            onSalesTargetChange({
              ...salesTarget,
              targetAmount: Number(numericVal),
            });
          }}
        />
        <span className="text-[#6D7C94] mt-3">Scope</span>
        <div className="w-full gap-3 flex mt-1">
          {scopeOptions.map((option, optionIndex) => {
            const isSelected = salesTarget?.scopes === option.value;
            return (
              <button
                key={optionIndex}
                className={`flex flex-1 items-center px-4 py-2 gap-2 rounded-md border-2 ${
                  isSelected
                    ? "bg-[#C4E9E3] border-[#016726]"
                    : "border-transparent bg-[#F8F8F8]"
                }`}
                onClick={() =>
                  onSalesTargetChange({ ...salesTarget, scopes: option.value })
                }
              >
                <div className="">
                  {isSelected ? (
                    <TaskAltIcon className="text-[#016726] text-2xl" />
                  ) : (
                    <div className="bg-[#DBDBDB] h-5 w-5 rounded-full"></div>
                  )}
                </div>
                <span className={`${isSelected ? "text-[#016726]" : ""}`}>
                  {option.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
      <CommonDropdownInput
        label="Time Frame"
        value={data?.timeFrame}
        onChange={(val) => setData({ ...data, timeFrame: val })}
        options={pointsConfig.timeFrameOptions}
      />
      <CommonFreeTextInput
        value={Number(data?.pointsRewarded).toLocaleString()}
        label="Points Rewarded"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          setData({ ...data, pointsRewarded: numericVal });
        }}
      />
    </div>
  );
}

export default PointsCreateMissionSalesTarget;
